import { useEffect, useRef, useState } from 'react';
import { loadThresholds, type Thresholds, type ThresholdStore } from './thresholds';
import { refreshThresholds } from './thresholdsApi';

export type DistrictYears = { years: Thresholds | null; settled: boolean };

export function useDistrictYears(store?: ThresholdStore | null): DistrictYears {
  const [state, setState] = useState<DistrictYears>({ years: null, settled: false });
  const storeRef = useRef(store);
  useEffect(() => {
    let active = true;
    const target = storeRef.current;
    const cached = () => (target === undefined ? loadThresholds() : loadThresholds(target));
    refreshThresholds(target)
      .then((years) => {
        if (active) setState({ years: years ?? cached(), settled: true });
      })
      .catch((err: unknown) => {
        console.warn('district years unavailable; using the last values this browser saw', err);
        if (active) setState({ years: cached(), settled: true });
      });
    return () => {
      active = false;
    };
  }, []);
  return state;
}
